import { START } from 'shared/data/quoteSteps';
import defaultParameters from 'shared/product_tabs/tab_assembly/data/defaultParameters';
import defaultQuote from 'shared/product_tabs/tab_assembly/data/defaultQuote';
import defaultSuppliers from 'shared/product_tabs/tab_assembly/data/defaultSuppliers';

const state = {
  loading: false,
  destroy: false,
  parametersChanged: false,
  quantitiesChanged: false,
  quoteStep: START,
  quote: defaultQuote,
  parameters: defaultParameters,
  suppliers: defaultSuppliers,
  lineItemId: null,
  currentVariant: null,
  zip_file_input_id: null,
};

export default state;
